import { Component, EventEmitter, OnInit, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { DuitLebih } from 'src/model/duitLebih.model';
import { TransactionSubType } from 'src/model/transactionSubType.model';

@Component({
    selector: 'app-add-duit-lebih',
    templateUrl: './add-duit-lebih.component.html',
    styleUrls: ['./add-duit-lebih.component.scss'],
    standalone: false
})
export class AddDuitLebihComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected sharedService = inject(SharedService);
  private enums = inject(Enums);

  subtypeList: TransactionSubType[] = [];
  amount: number;
  selectedSubType: number;

  @Output() passEntry = new EventEmitter<any>();

  ngOnInit(): void {
    this.getTransactionSubTypes();
  }

  getTransactionSubTypes() {
    const xhttp = this.restapi.getRequest(this.constructApi.getTransactionSubTypes(this.enums.EXTRAS));
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse((xhttp.responseText));

        jsonArray.forEach(json => {
          const type = new TransactionSubType(json.id, json.name, json.type, json.assignable, json.enabled);
          if (json.assignable == true)
            this.subtypeList.push(type);
        });
      }
    };
  }

  submit() {
    if (this.amount == undefined) {
      this.sharedService.openAlert("Please key in amount", ALERT_TYPE.DANGER);
    } else {
      const duitLebih = new DuitLebih(this.amount, this.selectedSubType)
      this.passEntry.emit(duitLebih);
      this.sharedService.openAlert("Successfully added duit lebih", ALERT_TYPE.SUCCESS);
      this.reset();
    }
  }

  reset() {
    this.activeModal.close();
  }
}
